export function extractAuthCode(input) {
	if (typeof input !== "string") {
		return null;
	}

	const trimmedInput = input.trim();
	if (!trimmedInput) {
		return null;
	}

	const candidates = [];

	if (trimmedInput.includes("://")) {
		const parsedUrl = new URL(trimmedInput);
		candidates.push(parsedUrl.search, parsedUrl.hash);
	}

	candidates.push(trimmedInput);

	for (const candidate of candidates) {
		const normalizedCandidate =
			candidate.startsWith("?") || candidate.startsWith("#")
				? candidate.slice(1)
				: candidate;

		if (!normalizedCandidate) {
			continue;
		}

		const params = new URLSearchParams(normalizedCandidate);
		const code = params.get("code");

		if (code) {
			return code;
		}
	}

	return null;
}